import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { theme } from '../../theme';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface SalesPipelineChartProps {
  parentToChild: {
    mode: string;
  };
}

const SalesPipelineChart: React.FC<SalesPipelineChartProps> = ({ parentToChild }) => {
  const { mode } = parentToChild;

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Sales Pipeline (Deals by Stage)',
        color: mode === 'dark' ? '#ffffff' : '#000000',
        font: {
          size: 14,
        },
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return context.parsed.x + ' deals';
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 60,
        ticks: {
          stepSize: 10,
          color: mode === 'dark' ? '#ffffff' : '#000000',
        },
        grid: {
          color: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
        },
        title: {
          display: true,
          text: 'Number of Deals',
          color: mode === 'dark' ? '#ffffff' : '#000000',
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          color: mode === 'dark' ? '#ffffff' : '#000000',
        },
      },
    },
  };

  const labels = ['Discovery', 'Proposal', 'Negotiation', 'Closing'];

  const data = {
    labels,
    datasets: [
      {
        data: [45, 32, 18, 8],
        backgroundColor: [
          theme.colors.secondary,
          '#747480', // A neutral gray
          '#b7ad6c', // A complementary color
          theme.colors.primary,
        ],
        borderRadius: 4,
      },
    ],
  };

  return (
    <div style={{ height: '250px', width: '100%' }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default SalesPipelineChart; 